/**
 * Input formatter to be used as :formatter method in bootstrap
 * b-form-input's.
 *
 * Filters every non-alpha character
 *
 * @param v   Value to format
 * @returns string  Formatted value
 */
const formatterCharFilterOnlyAplha = function (v) {
  return v.replace(/[^A-z\u00C0-\u00ff\-. ]/g, '')
}

export default {
  methods: {
    formatterCharFilterOnlyAplha
  }
}
